module.exports = __webpack_public_path__ + "img/3dbodytech.95f700ac.png";